import { useEffect } from 'react';
import { PASSIVE } from '../types';
import { useConstant } from './useConstant';
import { useFn } from './useFn';
export const useWindowEvent = (type, handler, opts = PASSIVE, enabled = true) => {
    type = useConstant(() => type);
    handler = useFn(handler);
    opts = useConstant(() => opts);
    useEffect(() => {
        // If event is toggled off, clean up and return
        if (!enabled)
            return window.removeEventListener(type, handler, opts);
        window.addEventListener(type, handler, opts);
        return () => window.removeEventListener(type, handler, opts);
    }, [enabled]);
};
//# sourceMappingURL=useWindowEvent.js.map